import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface MaintenancePageProps {
  message: string;
  showAdminLink?: boolean;
}

export function MaintenancePage({ message, showAdminLink = false }: MaintenancePageProps) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#f5f7fa] px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow p-8 text-center space-y-4">
        <h1 className="text-2xl font-bold text-[#1e3a4f]">Under maintenance</h1>
        <p className="text-muted-foreground">{message}</p>
        <div className="flex flex-col gap-2 pt-2">
          {showAdminLink && (
            <Button asChild className="bg-[#1e3a4f] hover:bg-[#163041]">
              <Link to="/admin/maintenance">Maintenance settings</Link>
            </Button>
          )}
          <Button asChild variant="secondary">
            <Link to="/login">Back to login</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
